import React from "react";
import FormField from "../components/FormField";

function NumberInput({
  label,
  name,
  value,
  onChange,
  placeholder,
  unit,
  required,
}) {
  const formatted = value ? Number(value).toLocaleString("en-US") : "";

  const handleChange = (e) => {
    const raw = e.target.value.replace(/,/g, "");
    if (raw === "" || /^\d+$/.test(raw)) {
      onChange({ target: { name, value: raw } });
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 mr-1">*</span>}
      </label>
      <div className="relative">
        <input
          type="text"
          inputMode="numeric"
          value={formatted}
          onChange={handleChange}
          placeholder={placeholder}
          className="w-full rounded border border-gray-300 px-3 py-2 text-left ltr pl-16 focus:outline-none focus:ring-2 focus:ring-sky-400"
          dir="ltr"
        />
        {unit && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400">
            {unit}
          </span>
        )}
      </div>
    </div>
  );
}

export default function Step3PaymentInfo({ data, onChange }) {
  return (
    <div>
      <h2 className="text-lg font-bold text-navy">مبلغ و شرایط معامله</h2>
      <p className="mt-1 text-sm text-gray-500">
        مبلغ کل معامله و نحوه پرداخت آن را مشخص کنید.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <NumberInput
          label="مبلغ کل به تومان"
          name="amountToman"
          value={data.amountToman}
          onChange={onChange}
          placeholder="مثلاً ۵۰۰,۰۰۰,۰۰۰"
          unit="تومان"
          required
        />
        <NumberInput
          label="مبلغ کل به ریال"
          name="amountRial"
          value={data.amountRial}
          onChange={onChange}
          placeholder="مثلاً ۵,۰۰۰,۰۰۰,۰۰۰"
          unit="ریال"
          required
        />
        <FormField
          label="شرایط پرداخت"
          name="paymentTerms"
          type="textarea"
          value={data.paymentTerms}
          onChange={onChange}
          placeholder="مثلاً مبلغ به صورت نقدی در زمان امضای قولنامه و مابقی طی دو قسط پرداخت می‌شود."
          full
        />
        <FormField
          label="توضیحات معامله"
          name="dealDescription"
          type="textarea"
          value={data.dealDescription}
          onChange={onChange}
          placeholder="هرگونه توضیح تکمیلی درباره معامله، تجهیزات اضافه، ضمانت‌ها و ..."
          full
          rows={4}
        />
      </div>
    </div>
  );
}
